
<nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Nuvarande elförbrukning</p>
      <p class="title">{{lastEnergyReadingObj?.currentConsumptionInWatts}} W</p>
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">&Delta;</p>

      @if (lastEnergyReadingObj?.deltaConsumption) {
        <p class="title">{{lastEnergyReadingObj?.deltaConsumption}} W</p>
      } @else {
        <p class="title">0 W</p>
      }
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Förbrukning (24h / 1h)</p>
      <p class="title">{{$safeNavigationMigration(lastEnergyReadingObj?.accumulatedConsumption) | number : '1.2-2'}} / {{$safeNavigationMigration(lastEnergyReadingObj?.accumulatedConsumptionLastHour) | number : '1.2-2'}} kWh</p>
    </div>
  </div>

  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Datum</p>
      <p class="title">{{$safeNavigationMigration(lastEnergyReadingObj?.sensorReadingDate) | date:'dd/MM HH:mm:ss'}}</p>
    </div>
  </div>
</nav>

<div class="level">
  <div class="level-item has-text-centered">
    <p>Senaste dygnet</p>
  </div>
</div>
<div class="columns is-mobile">
  <div class="column is-10 is-offset-1">
    @if (lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0) {
      <canvas baseChart width="300" height="100"
        [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)">
      </canvas>
    }
  </div>
</div>


<nav class="level">
  @if (lastEnergyReadingObj?.voltageL1) {
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">L1</p>
        <p class="title">{{lastEnergyReadingObj?.voltageL1}} V</p>
        <p class="title">{{lastEnergyReadingObj?.currentL1}} A</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">L2</p>
        <p class="title">{{lastEnergyReadingObj?.voltageL2}} V</p>
        <p class="title">{{lastEnergyReadingObj?.currentL2}} A</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">L3</p>
        <p class="title">{{lastEnergyReadingObj?.voltageL3}} V</p>
        <p class="title">{{lastEnergyReadingObj?.currentL3}} A</p>
      </div>
    </div>
  }
</nav>
